import type { Paginated } from '../../types/directMail';

/**
 * Drain a paginated list endpoint.
 *
 * The API runs DRF's PageNumberPagination without `page_size_query_param`, so
 * `page_size` is ignored and every list answers 20 rows. Pickers and the batch
 * builder need the whole set, not the first twenty, so they walk the pages.
 * The cap matches the backend's MAX_BULK_PINS — a selection larger than that is
 * rejected anyway, so there is nothing to gain by fetching past it.
 */
export async function loadAllPages<T>(
  fetchPage: (page: number) => Promise<Paginated<T>>,
  limit = 500,
): Promise<T[]> {
  const rows: T[] = [];
  let page = 1;

  while (rows.length < limit) {
    const result = await fetchPage(page);
    rows.push(...result.results);
    if (!result.next || result.results.length === 0) break;
    page += 1;
  }

  return rows.slice(0, limit);
}
